import { DatePicker } from 'antd'
import locale from 'antd/locale/es_ES'
import 'dayjs/locale/es'

export const LocalDatePicker = ({ ...props }: any) => <DatePicker {...props} format={'DD-MM-YYYY'} locale={locale} />
